// Mock data for CompreCliente website

export const siteConfig = {
  brand: "CompreCliente",
  whatsapp: "5513991980416",
  promo: {
    enabled: true,
    discount: "10%",
    get expires() {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },
    get monthName() {
      const month = new Date().toLocaleString('pt-BR', { month: 'long' });
      return month.charAt(0).toUpperCase() + month.slice(1);
    },
    get currentYearMonth() {
      const date = new Date();
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
    }
  },
  colors: {
    black: "#0B0B0C",
    gold: "#D4AF37",
    white: "#FFFFFF",
    gray: "#9CA3AF"
  }
};

export const testimonials = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1608222351212-18fe0ec7b13b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxtYXJrZXRpbmclMjBkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzYyNjU3ODA3fDA&ixlib=rb-4.1.0&q=85",
    text: "Conseguimos reduzir o CAC em 60% e triplicar o ROAS em 3 meses",
    author: "Pizzaria Bella Napoli"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1686061594225-3e92c0cd51b0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxtYXJrZXRpbmclMjBkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzYyNjU3ODA3fDA&ixlib=rb-4.1.0&q=85",
    text: "Viramos referência na região. Filas todos os dias graças ao trabalho impecável",
    author: "Burger House Premium"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1686061593213-98dad7c599b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwzfHxtYXJrZXRpbmclMjBkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzYyNjU3ODA3fDA&ixlib=rb-4.1.0&q=85",
    text: "Profissionalismo de outro nível. Cada centavo investido voltou multiplicado",
    author: "Restaurante Sabor & Arte"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxtYXJrZXRpbmclMjBkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzYyNjU3ODA3fDA&ixlib=rb-4.1.0&q=85",
    text: "Estrutura de campanha perfeita. Escalamos sem perder margem",
    author: "Delivery Express Gourmet"
  },
  {
    id: 5,
    image: "https://images.pexels.com/photos/95916/pexels-photo-95916.jpeg",
    text: "Melhor investimento que fizemos. Hoje somos a marca mais lembrada da cidade",
    author: "Chef's Table Restaurant"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Como funciona a Promoção do Mês?",
    answer: "A CompreCliente oferece 10% de desconto nos planos INTERMEDIÁRIO e AVANÇADO. A promoção é válida até o fim do mês vigente para novos contratos."
  },
  {
    id: 2,
    question: "Qual o prazo para começar a ver resultados?",
    answer: "Após o onboarding (7-14 dias), você começa a ver as primeiras métricas. Resultados consistentes aparecem entre 30-60 dias com otimizações contínuas. Trabalhamos com metas claras e ajustes baseados em dados."
  },
  {
    id: 3,
    question: "Tem contrato de fidelidade?",
    answer: "Sim, trabalhamos com contratos de 6 meses para garantir a continuidade das estratégias. Marketing digital exige tempo para maturar campanhas e gerar ROI consistente."
  },
  {
    id: 4,
    question: "O que está incluso no plano?",
    answer: "Todos os planos incluem: setup de campanhas, criativos, copy, otimizações, relatórios e suporte. A diferença está na frequência de entregas, volume de testes e nível de acompanhamento."
  },
  {
    id: 5,
    question: "Preciso fornecer fotos e vídeos?",
    answer: "Não necessariamente. Dependendo do plano, produzimos todo material criativo (fotos, vídeos, motion) ou aproveitamos o que você já tem otimizando para performance."
  },
  {
    id: 6,
    question: "Como funciona o suporte?",
    answer: "Básico: suporte em horário comercial via WhatsApp. Intermediário: suporte prioritário com SLA de 4h. Avançado: suporte VIP 24/7 com gestor dedicado. Empresarial: atendimento exclusivo com acesso direto à diretoria e war room mensal."
  },
  {
    id: 7,
    question: "Posso cancelar antes do término do contrato?",
    answer: "O contrato pode ser cancelado mediante aviso prévio de 30 dias e pagamento proporcional do período contratado. Buscamos relacionamentos de longo prazo baseados em resultados."
  },
  {
    id: 8,
    question: "Vocês trabalham com quais segmentos?",
    answer: "Especializados em food service (pizzarias, hamburguerias, restaurantes), mas atendemos diversos segmentos com estratégias personalizadas de tráfego pago e gestão de marca."
  }
];

export const servicesData = {
  home: {
    hero: {
      title: "SOLUÇÕES COMPRECLIENTE",
      subtitle: "Domine seu mercado com estratégias validadas",
      description: "Setup rápido, operação guiada, criativos que performam e estrutura de escala sem gambiarra."
    },
    authority: "Somos a assessoria de marketing que restaurantes e negócios locais escolhem quando querem sair do amadorismo e construir presença de marca real. Dados, processos, criativos e execução impecável. Sem promessas vazias, só resultados que você consegue medir.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Onboarding e setup completo",
          "Estratégia inicial + mapa de jornada",
          "1 iteração quinzenal de campanhas",
          "Biblioteca de criativos essenciais",
          "Relatório mensal de performance",
          "Suporte em horário comercial"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "Estratégia avançada multicanal",
          "2 iterações semanais de otimização",
          "Produção de criativos ilimitada",
          "Testes A/B estruturados",
          "Relatórios quinzenais + insights",
          "Suporte prioritário (SLA 4h)",
          "Acesso a dashboard em tempo real"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Direção criativa + growth sprint",
          "Produção dedicada (foto/vídeo)",
          "Relatórios semanais + war room mensal",
          "Consultoria estratégica de brand",
          "Prioridade máxima em demandas",
          "Suporte VIP 24/7",
          "Gestor de contas dedicado"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Squad dedicado (designer, copy, gestor)",
          "Consultoria de expansão de franquias",
          "Dashboards de BI personalizados",
          "Reunião mensal com diretoria",
          "Planejamento estratégico anual",
          "Soluções white-label (se aplicável)"
        ]
      }
    ]
  },
  metaAds: {
    hero: {
      title: "COMPRECLIENTE — Tráfego Pago Meta ADS",
      subtitle: "CAC otimizado, ROAS escalável e estrutura de campanha que performa",
      description: "Andromeda, CBO, criativos testados, compliance Meta e otimização contínua para extrair o máximo do seu budget."
    },
    authority: "Meta ADS exige estrutura, testes constantes e criativos que seguram atenção. Trabalhamos com metodologia Andromeda, segmentações inteligentes, copy persuasiva e otimizações diárias. Se você quer escalar sem queimar orçamento, está no lugar certo.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Setup completo Gerenciador de Anúncios",
          "Estrutura Andromeda (CBO + ABOs)",
          "Até 3 campanhas simultâneas",
          "5 criativos/mês (estáticos)",
          "Otimização quinzenal",
          "Relatório mensal com métricas chave"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "Até 6 campanhas simultâneas",
          "15 criativos/mês (estático + vídeo)",
          "Testes A/B de copy, criativo e público",
          "Otimização semanal baseada em dados",
          "Relatórios quinzenais + call de alinhamento",
          "Ajustes de budget em tempo real"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Campanhas ilimitadas + funis avançados",
          "Produção criativa dedicada (motion/3D)",
          "Retargeting estratégico multicanal",
          "Lookalike avançado + Custom Audiences",
          "War room mensal presencial ou remoto",
          "Suporte 24/7 com gestor dedicado"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Implementação API Conversões Server-side",
          "Dashboards em Data Studio/Power BI",
          "Auditoria externa trimestral",
          "Planejamento de expansão nacional",
          "Equipe de growth dedicada",
          "Integração com CRM Enterprise"
        ]
      }
    ]
  },
  googleAds: {
    hero: {
      title: "COMPRECLIENTE — Tráfego Pago Google ADS",
      subtitle: "Capte intenção de busca, domine localmente e maximize conversões",
      description: "Performance Max, Pesquisa, extensões otimizadas e gestão de negativos para garantir que cada clique vale a pena."
    },
    authority: "Google ADS é sobre capturar intenção. Trabalhamos com pesquisa estratégica, PMax para alcance amplo, otimização de Quality Score e geolocal perfeito. Palavras negativas, extensões relevantes e lances inteligentes para ROI máximo.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Setup Google Ads + Pixel",
          "Campanha de Pesquisa + Display",
          "Até 20 palavras-chave estratégicas",
          "Gestão de palavras negativas",
          "Extensões básicas (sitelink, local)",
          "Relatório mensal com insights"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "Performance Max + Shopping (se aplicável)",
          "Até 50 palavras-chave + long-tail",
          "Testes A/B de copy e landing pages",
          "Remarketing Google Display Network",
          "Otimização semanal de lances",
          "Relatórios quinzenais + call estratégica"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Múltiplas campanhas (Pesquisa, Display, Vídeo)",
          "Estratégia de lances automatizada (Target CPA/ROAS)",
          "Criação de landing pages otimizadas",
          "Integração GA4 + BigQuery para análise avançada",
          "War room mensal + suporte 24/7",
          "Gestor dedicado"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Scripts de automação personalizados",
          "Monitoramento de concorrentes em tempo real",
          "Estratégia de branding e market share",
          "Integração nativa com Salesforce/Hubspot",
          "Auditoria de contas globais",
          "Consultoria de atribuição avançada"
        ]
      }
    ]
  },
  socialMedia: {
    hero: {
      title: "COMPRECLIENTE — Social Media",
      subtitle: "Calendário editorial estratégico, identidade visual coesa e engajamento real",
      description: "Não é só postar: é construir presença, contar história e gerar conexão autêntica com sua audiência."
    },
    authority: "Gerenciamos redes sociais com propósito. Calendário editorial alinhado à estratégia, identidade visual marcante, copies que engajam e métricas que importam. Stories, feed, reels — tudo pensado para fortalecer sua marca.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "12 posts/mês (feed)",
          "Stories 3x/semana",
          "Calendário editorial mensal",
          "Identidade visual básica",
          "Monitoramento de comentários",
          "Relatório mensal de métricas"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "20 posts/mês (feed + carrossel)",
          "Stories diários + destaques organizados",
          "4 Reels/mês com edição profissional",
          "Gestão ativa de comunidade",
          "Estratégia de hashtags + SEO Instagram",
          "Relatório quinzenal + insights"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Posts ilimitados sob demanda",
          "8 Reels/mês + motion graphics",
          "Cobertura de eventos presenciais",
          "Parcerias com influencers locais",
          "Consultoria de posicionamento de marca",
          "War room mensal + suporte prioritário"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Cobertura de eventos em tempo real",
          "Gestão de influenciadores (nível nacional)",
          "Produção cinematográfica mensal",
          "Comitê de crise de imagem",
          "Community Manager dedicado",
          "Estratégia cross-channel (TT/LinkedIn)"
        ]
      }
    ]
  },
  socialMediaVitrine: {
    hero: {
      title: "COMPRECLIENTE — Social Media para Vitrine",
      subtitle: "Feed harmonizado, grid impecável e estética que vende antes do cliente ler",
      description: "Seu Instagram como vitrine digital premium: identidade visual coesa, padronização estética e grid que hipnotiza."
    },
    authority: "Para negócios onde o visual é decisivo (restaurantes, estética, moda), criamos feeds que funcionam como vitrines de luxo. Padrão cromático, composição equilibrada e identidade marcante que gera desejo à primeira vista.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "16 posts/mês com grid planejado",
          "Identidade visual padronizada",
          "Paleta de cores + templates",
          "Stories 2x/semana",
          "Planejamento de grid (3x3 ou 3x6)",
          "Relatório mensal"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "24 posts/mês com harmonia cromática",
          "Edição de fotos profissional",
          "Carrosséis temáticos",
          "Destaques organizados com capas personalizadas",
          "4 Reels com edição e vinhetas",
          "Acompanhamento quinzenal"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Produção fotográfica dedicada (mensal)",
          "Grid conceitual com storytelling visual",
          "Motion design e animações customizadas",
          "Rebranding completo se necessário",
          "Consultoria de posicionamento premium",
          "Suporte prioritário"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Direção de arte internacional",
          "Produção de editorial de moda/gastronomia",
          "Consultoria de arquitetura comercial",
          "Brand book completo e manual de marca",
          "Sessões fotográficas quinzenais",
          "Gestão de imagem pessoal do CEO"
        ]
      }
    ]
  },
  ensaiosFoodPorn: {
    hero: {
      title: "COMPRECLIENTE — Ensaios Visuais FOODPORN",
      subtitle: "Fotografia que vende: iluminação perfeita, ângulos estratégicos e fome instantânea",
      description: "Transformamos seus pratos em obras de arte que geram desejo, cliques e pedidos. Setup profissional, edição de cinema."
    },
    authority: "Food porn não é tirar foto de comida. É criar desejo visual. Trabalhamos com iluminação cinematográfica, composição estratégica, styling e pós-produção que fazem seu produto brilhar. Cada imagem é pensada para converter.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "1 sessão/mês (até 3h)",
          "Até 10 pratos fotografados",
          "20 fotos editadas entregues",
          "Edição básica (cor, luz, contraste)",
          "Entrega em 7 dias úteis",
          "Fotos otimizadas para redes sociais"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "2 sessões/mês (até 4h cada)",
          "Até 20 pratos fotografados",
          "50 fotos editadas + 10 vídeos curtos",
          "Edição avançada + retoques",
          "Props e styling inclusos",
          "Entrega em 5 dias úteis"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Sessões ilimitadas sob demanda",
          "Produção completa (locação, modelos)",
          "Fotos + vídeos em 4K com motion",
          "Banco de imagens mensal atualizado",
          "Direção de arte conceitual",
          "Entrega express (48h)"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Diárias ilimitadas de captação",
          "Equipe de cinema completa (DOP, Food Stylist)",
          "Captação para comerciais de TV/Cinema",
          "Licenciamento total de uso comercial",
          "Casting de modelos profissionais",
          "Aluguel de locações exclusivas"
        ]
      }
    ]
  },
  engenhariaCardapio: {
    hero: {
      title: "COMPRECLIENTE — Engenharia de Cardápio",
      subtitle: "Design que vende: psicologia, precificação estratégica e destaque visual nos itens certos",
      description: "Cardápio não é lista de produtos. É ferramenta de vendas. Criamos menus que guiam o olhar e aumentam ticket médio."
    },
    authority: "Aplicamos neuromarketing, hierarquia visual e precificação âncora para maximizar seu lucro. Destaque estratégico de itens premium, layout que facilita decisão e design que reflete o posicionamento da marca.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Análise do cardápio atual",
          "Reestruturação estratégica",
          "Design clean e funcional",
          "1 versão (digital ou impressa)",
          "Entrega em 10 dias úteis",
          "1 rodada de ajustes"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "Consultoria de precificação",
          "Destaque visual de itens âncora",
          "2 versões (digital + impressa)",
          "Cardápio para delivery adaptado",
          "Fotos dos pratos (se contratado ensaio)",
          "2 rodadas de ajustes"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Engenharia completa (menu engineering)",
          "Análise de margem e mix de produtos",
          "Design premium com acabamento especial",
          "Cardápio sazonal (4 versões/ano)",
          "Consultoria de posicionamento",
          "Revisões ilimitadas"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Cardápio digital com IA integrada",
          "Treinamento de equipe de salão (venda sugestiva)",
          "Análise de concorrentes in loco",
          "Renovação trimestral garantida",
          "Implementação de totens de autoatendimento",
          "Sessão de fotos profissional inclusa"
        ]
      }
    ]
  },
  edicao: {
    hero: {
      title: "COMPRECLIENTE — Edição de Vídeo/Imagem",
      subtitle: "Pós-produção cinematográfica: color grading, motion e cortes que prendem atenção",
      description: "Transformamos material bruto em conteúdo premium. Edição ágil, qualidade de cinema, otimizado para performance."
    },
    authority: "Editamos pensando em retenção e conversão. Color grading profissional, motion graphics, legendas estratégicas, cortes dinâmicos e exportação otimizada para cada plataforma. Seu conteúdo merece tratamento premium.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Até 5 vídeos curtos/mês (até 60s)",
          "Edição básica com cortes",
          "Legendas automáticas",
          "Trilha sonora livre de direitos",
          "Exportação para 1 plataforma",
          "Entrega em 5 dias úteis"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "Até 15 vídeos/mês (curtos + médios)",
          "Color grading profissional",
          "Motion graphics e animações",
          "Legendas manuais revisadas",
          "Exportação multi-plataforma",
          "Entrega em 3 dias úteis"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Vídeos ilimitados sob demanda",
          "Edição cinematográfica avançada",
          "Efeitos visuais customizados",
          "Vinhetas e intro personalizadas",
          "Banco de vídeos atualizado mensalmente",
          "Entrega express (24-48h)"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Equipe de pós-produção dedicada",
          "Color grading cinema (DaVinci Resolve)",
          "VFX e 3D avançado",
          "Armazenamento em nuvem ilimitado (RAW)",
          "Servidor dedicado para render farm",
          "Atendimento in-loco para DIT"
        ]
      }
    ]
  },
  copyRoteiros: {
    hero: {
      title: "COMPRECLIENTE — Copy + Roteiros que Vendem",
      subtitle: "Hooks que seguram, estruturas que convertem e roteiros que geram ação",
      description: "Palavras certas no momento certo. Criamos copies persuasivas e roteiros estratégicos para anúncios, vídeos e stories."
    },
    authority: "Escrevemos para vender. Usamos gatilhos mentais, estruturas comprovadas (PAS, AIDA) e tom de voz que ressoa com seu público. De hooks de 3 segundos a roteiros completos de VSL, cada palavra trabalha para conversão.",
    plans: [
      {
        name: "Básico",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "10 copies/mês (anúncios ou posts)",
          "3 roteiros curtos (até 60s)",
          "Hooks e CTAs estratégicos",
          "Revisão de tom de voz",
          "Entrega em 5 dias úteis",
          "1 rodada de ajustes"
        ]
      },
      {
        name: "Intermediário",
        price: "Sob Consulta",
        originalPrice: null,
        featured: true,
        features: [
          "Tudo do Básico +",
          "25 copies/mês",
          "8 roteiros (curtos e médios)",
          "Storytelling estruturado",
          "Variações para testes A/B",
          "Consultoria de mensagem e posicionamento",
          "Entrega em 3 dias úteis"
        ]
      },
      {
        name: "Avançado",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Intermediário +",
          "Copies e roteiros ilimitados",
          "VSL completo (Video Sales Letter)",
          "Sequências de email marketing",
          "Landing pages otimizadas",
          "Consultoria estratégica de brand voice",
          "Entrega prioritária (24-48h)"
        ]
      },
      {
        name: "Empresarial",
        price: "Sob Consulta",
        originalPrice: null,
        featured: false,
        features: [
          "Tudo do Avançado +",
          "Roteirista de TV/Cinema dedicado",
          "Ghostwriting para livros/autoridade",
          "Estratégia de lançamento completa",
          "Tradução e localização internacional",
          "Workshops de storytelling para equipe",
          "Auditoria de comunicação corporativa"
        ]
      }
    ]
  }
};
